import Prose from "@liberetech/design-system/Prose";
import Section, { SectionProps } from "@liberetech/design-system/Section";
import SectionHeader from "@liberetech/design-system/SectionHeader";
import classNames from "classnames";

import styles from "./SectionFAQs.module.css";

const SectionFAQs: React.FC<SectionFAQProps> = ({
  faqs,
  title,
  label,
  background,
  ...rest
}) => (
  <Section
    className={classNames(styles.faq, {
      [styles.faqContrast]: background === "contrast",
    })}
    id="faq"
    background={background}
    {...rest}
  >
    <SectionHeader centered label={label} title={title} className="grid" />
    <ul className={classNames(styles.faqs, "grid")}>
      {faqs.map((faq, i) => (
        <li key={i}>
          <div className={styles.faqItem}>
            <div className={styles.faqHeader}>
              <h3 className={styles.faqQuestion}>{faq.question}</h3>
            </div>
            <Prose className={styles.faqAnswer} compact>
              <div dangerouslySetInnerHTML={{ __html: faq.answer }} />
            </Prose>
          </div>
        </li>
      ))}
    </ul>
  </Section>
);

export default SectionFAQs;

type SectionFAQProps = {
  faqs: Array<{
    question: string;
    answer: string;
  }>;
  label?: string;
  title: string;
} & SectionProps;
